import React from 'react';

import {QueryingChartContent} from 'charts/chart-content/ChartContent';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import getTestProps from 'test/lib/cypress/getTestProps';

interface NoteLinkedChartViewProps {
  chartId: string;
}
export default function NoteLinkedChartView({chartId}: NoteLinkedChartViewProps): JSX.Element {
  const {isExportView, isPrintPreviewView} = EditorPropertiesContext.useContext();
  return (
    <span {...getTestProps({component: 'NoteLinkedChartView', element: 'root'})}>
      <QueryingChartContent chartId={chartId} renderStaticChart={isExportView || isPrintPreviewView} />
    </span>
  );
}
